import React, { Component } from "react";
import { readStorageJSON, project, format_date, loading, toFixed, replaceTextHTML, GET } from "../components/CustomComponent.js";
import LOGO from "../assets/images/logo.png";
import THBText from "thai-baht-text";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
import "../assets/css/pdf.css";
function parsePythonDictOrJson(str) {
  // ค่าเสียแปลงไม่ได้ = null (caller ใช้ค่า default ของหน้าแทน) ห้าม throw
  const asObject = (v) => (v !== null && typeof v === 'object' ? v : null);
  try {
    return asObject(JSON.parse(str));
  } catch (_) {
    try {
      const json = str
        .replace(/True/g, 'true')
        .replace(/False/g, 'false')
        .replace(/None/g, 'null')
        .replace(/'/g, '"');
      return asObject(JSON.parse(json));
    } catch (__) {
      return null;
    }
  }
}

const size = {
  A4: { width: 1116, height: 1578 },
  A5: { width: 1116, height: 1578, zoom: 0.5 },
  "4.5 x 5.5 นิ้ว": { width: 1116, height: 1371, zoom: 0.385 },
  "9 x 11 นิ้ว": { width: 1116, height: 1371, zoom: 0.77 },
  "9 x 5.5 นิ้ว": { width: 1116, height: 806, zoom: 0.77 },
};
export default class PaymentHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      data: null,
      setting: {
        size: "9 x 5.5 นิ้ว", // A4, A5, 4.5 x 5.5 นิ้ว, 9 x 11 นิ้ว, 9 x 5.5 นิ้ว
        paddingLeft: 23,
        paddingRight: 45,
        paddingTop: 24,
        paddingBottom:32,
        header_1: { status: true, title: "-โลโก้" },
        header_2: { status: true, title: "" }, // โครงการ
        header_3: { status: true, title: "" }, // ที่อยู่
        header_4: { status: true, title: "-ใบเสร็จรับเงิน" },
        header_5: { status: true, title: "-เลขที่" },
        header_6: { status: true, title: "-วันที่" },
        header_7: { status: true, title: "-ได้รับเงินจาก" },
        header_8: { status: true, title: "-ที่อยู่" },
        header_9: { status: true, title: "-ชำระโดย" },
        header_10: { status: true, title: "-วันที่" },

        th_1: { status: true, title: "-ลำดับ" },
        th_2: { status: true, title: "-รายการ" },
        th_3: { status: true, title: "-เลขมาตรจดครั้งนี้" },
        th_4: { status: true, title: "-เลขมาตรจดครั้งก่อน" },
        th_5: { status: true, title: "-จำนวนหน่วยที่ใช้" },
        th_6: { status: true, title: "-รวมเป็นเงิน" },

        tr_1: { status: true, title: "-ค่าน้ำประปา" },
        tr_2: { status: true, title: "-ค่าบริการรักษาอุปกรณ์น้ำ" },
        tr_3: { status: true, title: "-ค่าบริการจัดเก็บขยะ" },
        tr_4: { status: true, title: "-ค่าใช้จ่ายส่วนกลาง" },
        tr_5: { status: true, title: "-ค้างชำระ" },
        tr_6: { status: true, title: "-อื่นๆ" },
        tr_6_1: { status: true, title: "-ค่าต่อกลับมิเตอร์" },
        tr_6_2: { status: true, title: "-ค่าปรับล่าช้า" },
        tr_6_3: { status: true, title: "-ค่าเบี้ยประกัน" },
        tr_6_4: { status: true, title: "-ค่าบริการเคเบิล" },
        tr_6_5: { status: true, title: "" }, // ค่าอื่นๆ
        tr_7: { status: true, title: "-รายการลดหนี้" },
        tr_8: { status: true, title: "-รายการเพิ่มหนี้" },

        tr_9: { status: true, title: "-รวมเป็นเงิน" },
        tr_10: { status: true, title: "-ปรับปรุงยอดเงิน" },
        tr_11: { status: true, title: "-รวมเป็นเงินทั้งสิ้น" },

        footer_1: { status: true, title: "-จำนวนเงิน (ตัวอักษร)" },
        footer_2: { status: true, title: "" }, // หมายเหตุ
        footer_3: { status: true, title: "-ลงชื่อ" },
        footer_4: { status: true, title: "" }, // ชื่อผู้รับเงิน
        footer_5: { status: true, title: "" }, // ตำแหน่งผู้รับเงิน
      },
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get();
    this.setState({ data: readStorageJSON("DATA_") });
    await replaceTextHTML();
    setTimeout(() => {
      window.print();
    }, 1000);
  }

  Get = async () => {
    const settings = readStorageJSON("cds-setting") || {};
    const raw = settings?.setting_document_custom?.[0]?.receipt;
    const parsed = raw
      ? (typeof raw === 'string' ? parsePythonDictOrJson(raw) : raw) || this.state.setting
      : this.state.setting;
    this.setState({ setting: parsed });

    const array = Object.entries(parsed);
    for (let item of array) {
      if (!item[1].status) {
        try {
          let component = document.getElementsByClassName(item[0]);
          for (let co of component) {
            co.classList.add("d-none");
          }
        } catch (e) {}
      }
    }
    if (!parsed.header_1?.status && !parsed.header_2?.status && !parsed.header_3?.status && !parsed.header_5?.status && !parsed.header_6?.status) {
      document.getElementsByClassName("header_1_2_3_4_5_6")[0]?.classList.add("d-none");
    }
    if (!parsed.header_5?.status && !parsed.header_6?.status) {
      document.getElementsByClassName("header_5_6")[0]?.classList.add("d-none");
    }
    if (!parsed.header_7?.status && !parsed.header_8?.status && !parsed.header_9?.status && !parsed.header_10?.status) {
      document.getElementsByClassName("header_7_8_9_10")[0]?.classList.add("d-none");
    }

    // ดึงข้อมูลโครงการ (รวมรูปหัวกระดาษ) สดจาก API แทนการเชื่อ localStorage ที่อาจเก่ากว่าข้อมูลจริงใน DB
    if (project?.project_id) {
      const fresh = await GET("api/public/project", { project_id: project.project_id });
      if (fresh?.status && fresh.data) {
        this.setState({ picture_paper: fresh.data.picture_paper || "" });
      }
    }
  };
  render() {
    const { setting: s, data: d } = this.state;

    // Helper สำหรับซ่อน Element ตามค่าที่ตั้งจากหน้าตั้งค่าใบเสร็จ (เหมือน P1)
    const chk = (key) => (!s[key]?.status ? "d-none" : "");
    const hideHeaderTop = (!s.header_1?.status && !s.header_2?.status && !s.header_3?.status && !s.header_5?.status && !s.header_6?.status) ? "d-none" : "";
    const hideHeader56 = (!s.header_5?.status && !s.header_6?.status) ? "d-none" : "";
    const hideHeader7to10 = (!s.header_7?.status && !s.header_8?.status && !s.header_9?.status && !s.header_10?.status) ? "d-none" : "";

    // Helper สำหรับคำนวณลำดับข้อ
    const rIdx = (keys) => keys.reduce((sum, k) => sum + (s[k]?.status ? 1 : 0), 0);
    const tr2 = ['tr_1', 'tr_2'];
    const tr3 = [...tr2, 'tr_3'];
    const tr4 = [...tr3, 'tr_4'];
    const tr5 = [...tr4, 'tr_5'];
    const tr6 = [...tr5, 'tr_6'];
    const tr7 = [...tr6, 'tr_7'];
    const tr8 = [...tr7, 'tr_8'];

    // คำนวณวันที่และยอดรวม
    const nextMonth = d?.water_current_month ? new Date(new Date(d.water_current_month).setMonth(new Date(d.water_current_month).getMonth() + 1)) : null;
    const grandTotal = Number(d?.total || 0) + Number(d?.change_satang || 0);

    return (
      <div className="w-100">
        <div
          className={"mx-auto bg-white border-bottom " + (s.size === "9 x 5.5 นิ้ว" ? "pdf-small" : "pdf")}
          style={{
            ...size[s.size || "A4"],
            paddingLeft: Number(s.paddingLeft),
            paddingRight: Number(s.paddingRight),
            paddingTop: Number(s.paddingTop),
            paddingBottom: Number(s.paddingBottom),
          }}>

          <table className="table table-bordered mb-0 header">
            <tbody>
              <tr className={`border-bottom-0 ${hideHeaderTop}`}>
                <td rowSpan={2}>
                  <div className="d-flex align-items-center">
                    <img src={this.state.picture_paper || project?.picture_paper || LOGO} style={{ width: 92, height: 92, objectFit: "contain", marginRight: 6 }} alt="LOGO" className={`bg-contain ${chk("header_1")}`} />
                    <div>
                      <h2 className={`fw-bold px-2 mb-0 ${chk("header_2")}`}>{s.header_2?.title || ""}</h2>
                      <div className={`px-2 ${chk("header_3")}`}>
                        {s.header_3?.title?.split("\n").map((e, i) => <div key={i}>{e}</div>)}
                      </div>
                    </div>
                  </div>
                </td>
                <td className={`wpx-250 text-center border-bottom-0 ${chk("header_4")}`}>
                  <h2 className="fw-bold mb-0">ใบเสร็จรับเงิน</h2>
                </td>
              </tr>
              <tr className={hideHeader56}>
                <td className="border-bottom-0 wpx-250">
                  <div className={chk("header_5")}>เลขที่ : {d?.number}</div>
                  <div className={chk("header_6")}>วันที่ : {d?.date}</div>
                </td>
              </tr>
              <tr className={hideHeader7to10}>
                <td className="border-bottom-0">
                  <div className={chk("header_7")}>ได้รับเงินจาก : {d?.cutomer_name}</div>
                  <div className={chk("header_8")}>ที่อยู่ : {d?.cutomer_address}</div>
                </td>
                <td className="border-bottom-0 wpx-250">
                  <div className={chk("header_9")}>ชำระโดย : {d?.payment}</div>
                  <div className={chk("header_10")}>วันที่ : {d?.payment_date}</div>
                </td>
              </tr>
            </tbody>
          </table>

          <table className="table table-bordered mb-0">
            <tbody>
              <tr>
                <td className={`text-center wpx-50 ${chk("th_1")}`}>ลำดับ<br/><span> </span></td>
                <td className={`w-100 ${chk("th_2")}`}>รายการ<br/><span> </span></td>
                <td className={chk("th_3")}>
                  <div className="text-nowrap mx-1">
                    เลขมาตรจดครั้งนี้<br />วันที่ {format_date(d?.water_current_month)}
                  </div>
                </td>
                <td className={chk("th_4")}>
                  <div className="text-nowrap mx-1">
                    เลขมาตรจดครั้งก่อน<br />วันที่ {format_date(d?.water_last_month || d?.water_current_month)}
                  </div>
                </td>
                <td className={`text-center wpx-130 ${chk("th_5")}`}>จำนวนหน่วยที่ใช้<br/><span> </span></td>
                <td className={`text-center wpx-120 ${chk("th_6")}`}>รวมเป็นเงิน<br/><span> </span></td>
              </tr>
              <tr className={chk("tr_1")}>
                <td className={`pt-1 text-center ${chk("th_1")}`}>1</td>
                <td className={`pt-1 border-right-0 w-100 ${chk("th_2")}`}>ค่าน้ำประปา ประจำเดือน {format_date(d?.water_current_month, "mmmm yyyy")}</td>
                <td className={`text-end ${chk("th_3")}`}>{d?.current_gauge_number}</td>
                <td className={`text-end ${chk("th_4")}`}>{d?.last_gauge_number}</td>
                <td className={`text-end ${chk("th_5")}`}>{d?.unit_used}</td>
                <td className={`text-end ${chk("th_6")}`}>{toFixed(d?.water_bill)}</td>
              </tr>
              <tr className={chk("tr_2")}>
                <td className={`pt-1 text-center ${chk("th_1")}`}>{rIdx(tr2)}</td>
                <td className={`pt-1 border-right-0 w-100 ${chk("th_2")}`}>ค่าบริการรักษาอุปกรณ์น้ำ {format_date(d?.water_current_month, "mmmm yyyy")}</td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_3")}`}></td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_4")}`}></td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_5")}`}></td>
                <td className={`text-end ${chk("th_6")}`}>{toFixed(d?.equipment_maintenance_fee)}</td>
              </tr>
              <tr className={chk("tr_3")}>
                <td className={`pt-1 text-center ${chk("th_1")}`}>{rIdx(tr3)}</td>
                <td className={`pt-1 border-right-0 w-100 ${chk("th_2")}`}>ค่าบริการจัดเก็บขยะ {format_date(d?.water_current_month, "mmmm yyyy")}</td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_3")}`}></td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_4")}`}></td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_5")}`}></td>
                <td className={`text-end ${chk("th_6")}`}>{toFixed(d?.waste_cost)}</td>
              </tr>
              <tr className={chk("tr_4")}>
                <td className={`pt-1 text-center ${chk("th_1")}`}>{rIdx(tr4)}</td>
                <td className={`pt-1 border-right-0 w-100 ${chk("th_2")}`}>ค่าใช้จ่ายส่วนกลาง ประจำเดือน {format_date(nextMonth, "mmmm yyyy")}</td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_3")}`}></td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_4")}`}></td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_5")}`}></td>
                <td className={`text-end ${chk("th_6")}`}>{toFixed(d?.common_expenses)}</td>
              </tr>
              <tr className={chk("tr_5")}>
                <td className={`pt-1 text-center ${chk("th_1")}`}>{rIdx(tr5)}</td>
                <td className={`pt-1 border-right-0 w-100 ${chk("th_2")}`}>ค้างชำระจำนวน {Math.max((d?.water_list?.length || 1) - 1, 0)} งวด</td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_3")}`}></td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_4")}`}></td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_5")}`}></td>
                <td className={`text-end ${chk("th_6")}`}>{toFixed(d?.water_list_price)}</td>
              </tr>
              <tr className={chk("tr_6")}>
                <td className={`pt-1 text-center ${chk("th_1")}`}>{rIdx(tr6)}</td>
                <td className={`pt-1 border-right-0 w-100 ${chk("th_2")}`}>อื่นๆ</td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_3")}`}></td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_4")}`}></td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_5")}`}></td>
                <td className={`text-end ${chk("th_6")}`}></td>
              </tr>
              <tr className={chk("tr_6_1")}>
                <td className={`pt-1 text-center ${chk("th_1")}`}>{rIdx(tr6)}.{rIdx(['tr_6_1'])}.</td>
                <td className={`pt-1 border-right-0 w-100 ${chk("th_2")}`}>ค่าต่อกลับมิเตอร์</td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_3")}`}></td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_4")}`}></td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_5")}`}></td>
                <td className={`text-end ${chk("th_6")}`}>{toFixed(d?.meter_connect_cost)}</td>
              </tr>
              <tr className={chk("tr_6_2")}>
                <td className={`pt-1 text-center ${chk("th_1")}`}>{rIdx(tr6)}.{rIdx(['tr_6_1', 'tr_6_2'])}.</td>
                <td className={`pt-1 border-right-0 w-100 ${chk("th_2")}`}>ค่าปรับล่าช้า</td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_3")}`}></td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_4")}`}></td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_5")}`}></td>
                <td className={`text-end ${chk("th_6")}`}>{toFixed(d?.total_cost_late)}</td>
              </tr>
              <tr className={chk("tr_6_3")}>
                <td className={`pt-1 text-center ${chk("th_1")}`}>{rIdx(tr6)}.{rIdx(['tr_6_1', 'tr_6_2', 'tr_6_3'])}.</td>
                <td className={`pt-1 border-right-0 w-100 ${chk("th_2")}`}>ค่าเบี้ยประกัน</td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_3")}`}></td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_4")}`}></td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_5")}`}></td>
                <td className={`text-end ${chk("th_6")}`}>{toFixed(d?.fire_cost)}</td>
              </tr>
              <tr className={chk("tr_6_4")}>
                <td className={`pt-1 text-center ${chk("th_1")}`}>{rIdx(tr6)}.{rIdx(['tr_6_1', 'tr_6_2', 'tr_6_3', 'tr_6_4'])}.</td>
                <td className={`pt-1 border-right-0 w-100 ${chk("th_2")}`}>ค่าบริการเคเบิล</td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_3")}`}></td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_4")}`}></td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_5")}`}></td>
                <td className={`text-end ${chk("th_6")}`}>{toFixed(d?.cable_cost)}</td>
              </tr>
              <tr className={chk("tr_6_5")}>
                <td className={`pt-1 text-center ${chk("th_1")}`}>{rIdx(tr6)}.{rIdx(['tr_6_1', 'tr_6_2', 'tr_6_3', 'tr_6_4', 'tr_6_5'])}.</td>
                <td className={`pt-1 border-right-0 w-100 ${chk("th_2")}`}>{s?.tr_6_5.title}</td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_3")}`}></td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_4")}`}></td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_5")}`}></td>
                <td className={`text-end ${chk("th_6")}`}>{toFixed(d?.other_income)}</td>
              </tr>
              <tr className={chk("tr_7")}>
                <td className={`pt-1 text-center ${chk("th_1")}`}>{rIdx(tr7)}</td>
                <td className={`pt-1 border-right-0 w-100 ${chk("th_2")}`}>รายการลดหนี้</td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_3")}`}></td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_4")}`}></td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_5")}`}></td>
                <td className={`text-end ${chk("th_6")}`}>-{toFixed((d?.reduce_debt || 0) + (d?.add_on_reduce_debt || 0))}</td>
              </tr>
              <tr className={chk("tr_8")}>
                <td className={`pt-1 text-center ${chk("th_1")}`}>{rIdx(tr8)}</td>
                <td className={`pt-1 border-right-0 w-100 ${chk("th_2")}`}>รายการเพิ่มหนี้</td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_3")}`}></td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_4")}`}></td>
                <td className={`border-left-0 border-right-0 text-end ${chk("th_5")}`}></td>
                <td className={`text-end ${chk("th_6")}`}>{toFixed((d?.add_debt || 0) + (d?.add_on_add_debt || 0))}</td>
              </tr>
            </tbody>
          </table>

          <table className="table table-bordered mb-0 w-100">
            <tbody>
              <tr>
                <td colSpan={rIdx(['th_1', 'th_2', 'th_3', 'th_4'])} rowSpan={3} className="border-0">
                  <div className="d-flex">
                    <div className="w-100">
                      <div className={`w-100 d-flex position-relative mt-3 text-nowrap ${chk("footer_1")}`}>
                        จำนวนเงิน (ตัวอักษร)
                        <div className="w-100 pl-1 position-relative">
                          ....................................................................................
                          <span className="position-absolute" style={{ left: 6, bottom: 4 }}>
                            {THBText(grandTotal)}
                          </span>
                        </div>
                      </div>
                      <div className={`text-wrap ${chk("footer_2")}`} style={{ maxWidth: 490 }}>
                        {s.footer_2?.title?.split("\n").map((e, i) => <div key={i}>{e}</div>)}
                      </div>
                    </div>
                    <div className="text-center">
                      <br /><br />
                      <div className={`text-nowrap ${chk("footer_3")}`}>ลงชื่อ...............................................ผู้รับเงิน</div>
                      <div className={chk("footer_4")}>({s.footer_4?.title})</div>
                      <div className={chk("footer_5")}>{s.footer_5?.title}</div>
                    </div>
                  </div>
                </td>
                <td className={`text-end border-top-0 text-end wpx-130 pr-1 border-0 ${chk("tr_9")}`}>รวมเป็นเงิน</td>
                <td className={`text-end border-top-0 text-end wpx-120 ${chk("tr_9")}`}>{toFixed(d?.total)}</td>
              </tr>
              <tr className={chk("tr_10")}>
                <td className="text-end border-top-0 text-end wpx-130 pr-1 border-0">ปรับปรุงยอดเงิน</td>
                <td className="text-end border-top-0 text-end wpx-120">{toFixed(d?.change_satang)}</td>
              </tr>
              <tr className={chk("tr_11")}>
                <td className="text-end border-top-0 text-end wpx-130 pr-1 border-0">รวมเป็นเงินทั้งสิ้น</td>
                <td className="text-end border-top-0 text-end wpx-120">{toFixed(grandTotal)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
